import { useRef } from 'react';
import { createPortal } from 'react-dom';
var ID = 'cactus-portal-root';
export var getPortalRoot = function getPortalRoot() {
  var div = document.getElementById(ID);

  if (!div) {
    div = document.createElement('div');
    div.id = ID;
    document.body.appendChild(div);
  }

  return div;
};
export var usePortal = function usePortal(contents, key) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = getPortalRoot();
  }

  return contents ? /*#__PURE__*/createPortal(contents, ref.current, key) : null;
};